import { render } from "./LiteralURLList.vue?vue&type=template&id=e2defb90"
import script from "./LiteralURLList.vue?vue&type=script&lang=js"
export * from "./LiteralURLList.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__